import { defineComponent, computed, provide, ref, onMounted, watch, onBeforeUnmount, openBlock, createElementBlock, normalizeClass, renderSlot, toDisplayString, createCommentVNode, createElementVNode, inject } from 'vue';

var script$2 = defineComponent({
    name: 'Loading',
    props: {
        prefix: {
            type: String,
            default: ''
        },
        text: {
            type: String,
            default: 'Loading…'
        },
        labelTransitions: {
            type: Boolean,
            default: false
        },
        labelPosition: {
            type: String,
            default: 'center'
        }
    },
    setup(props, { slots }) {
        var _a, _b;
        const baseClass = computed(() => `${props.prefix}loading`);
        provide('prefix', props);
        const displayText = ref(props.text);
        const fadeIn = ref(false);
        const fadeOut = ref(false);
        const child = (_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots)[0];
        const shouldRenderLabel = !((_b = child === null || child === void 0 ? void 0 : child.props) === null || _b === void 0 ? void 0 : _b.size) || child.props.size === 'large';
        const fadeInTimer = ref();
        const fadeOutTimer = ref();
        const animateText = (unmount) => {
            if (!unmount && props.labelTransitions && (props.text !== displayText.value)) {
                fadeIn.value = false;
                fadeOut.value = true;
                fadeOutTimer.value = setTimeout(() => {
                    fadeOut.value = false;
                    fadeInTimer.value = setTimeout(() => {
                        fadeIn.value = true;
                        displayText.value = props.text;
                    }, 100);
                }, 100);
            }
            else if (unmount) {
                clearTimeout(fadeOutTimer.value);
                clearTimeout(fadeInTimer.value);
            }
            else {
                fadeIn.value = true;
                displayText.value = props.text;
            }
        };
        // Run animateText on mount
        onMounted(() => animateText(false));
        // Watch for any changes in text props, then run animateText
        watch(() => props.text, () => animateText(false));
        // Clear timeouts on Unmount
        onBeforeUnmount(() => animateText(true));
        return { baseClass, displayText, fadeIn, fadeOut, shouldRenderLabel };
    }
});

function render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createElementBlock("span", {
    class: normalizeClass([
      _ctx.baseClass,
      `${_ctx.baseClass}--label-${_ctx.labelPosition}`
    ]),
    "aria-live": "polite"
  }, [
    renderSlot(_ctx.$slots, "default"),
    (_ctx.shouldRenderLabel)
      ? (openBlock(), createElementBlock("span", {
          key: 0,
          "aria-hidden": "true",
          class: normalizeClass([
        `${_ctx.baseClass}__text`,
        {
          [`${_ctx.baseClass}__text--fade-out`]: _ctx.fadeOut,
          [`${_ctx.baseClass}__text--fade-in`]: _ctx.fadeIn
        }
      ])
        }, toDisplayString(_ctx.displayText), 3 /* TEXT, CLASS */))
      : createCommentVNode("v-if", true),
    createElementVNode("span", {
      class: normalizeClass(`${_ctx.baseClass}__sr-only-text`)
    }, toDisplayString(_ctx.$props.text), 3 /* TEXT, CLASS */)
  ], 2 /* CLASS */))
}

script$2.render = render$2;
script$2.__file = "packages/vue/loading/lib/Loading.vue";

var script$1 = defineComponent({
    name: 'LoadingBall',
    props: {
        prefix: {
            type: String,
            default: ''
        },
        size: {
            type: String,
            default: 'large'
        },
        color: {
            type: String,
            default: 'emphasised'
        }
    },
    setup(props) {
        const parentProps = inject('prefix', { prefix: props.prefix });
        const baseClass = computed(() => `${parentProps.prefix}loading`);
        return { baseClass };
    }
});

function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createElementBlock("span", {
    class: normalizeClass([
      `${_ctx.baseClass}__ball`,
      `${_ctx.baseClass}__ball--${_ctx.size}`,
      `${_ctx.baseClass}__ball--${_ctx.color}`
    ]),
    "aria-hidden": "true"
  }, null, 2 /* CLASS */))
}

script$1.render = render$1;
script$1.__file = "packages/vue/loading/lib/LoadingBall.vue";

var script = defineComponent({
    name: 'LoadingLinear',
    props: {
        prefix: {
            type: String,
            default: ''
        },
        loadingValue: {
            type: Number,
            default: 0
        },
        loadingMax: {
            type: Number,
            default: 100
        },
        loadingLabel: {
            type: String,
            default: undefined
        }
    },
    setup(props) {
        const currentValue = computed(() => {
            return props.loadingValue > props.loadingMax ? props.loadingMax : props.loadingValue;
        });
        const parentProps = inject('prefix', { prefix: props.prefix });
        const baseClass = computed(() => `${parentProps.prefix}loading`);
        return { currentValue, baseClass };
    }
});

const _hoisted_1 = ["value", "max", "aria-valuenow", "aria-valuemax"];

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createElementBlock("span", {
    class: normalizeClass(`${_ctx.baseClass}__linear-wrapper`)
  }, [
    createElementVNode("label", {
      class: normalizeClass(`${_ctx.baseClass}__linear-label`)
    }, toDisplayString(_ctx.loadingLabel), 3 /* TEXT, CLASS */),
    createElementVNode("progress", {
      class: normalizeClass(`${_ctx.baseClass}__linear-progress`),
      value: _ctx.currentValue,
      max: _ctx.loadingMax,
      "aria-valuemin": "0",
      "aria-valuenow": _ctx.currentValue,
      "aria-valuemax": _ctx.loadingMax
    }, null, 10 /* CLASS, PROPS */, _hoisted_1)
  ], 2 /* CLASS */))
}

script.render = render;
script.__file = "packages/vue/loading/lib/LoadingLinear.vue";

export { script$1 as LoadingBall, script as LoadingLinear, script$2 as default };
